export default __webpack_public_path__ + "static/media/marketing-services-banner.7cef1375.png";